"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var userApi = _interopRequireWildcard(require("@/api/user"));
var companyappApi = _interopRequireWildcard(require("@/api/companyappApi"));
var _selectUser = _interopRequireDefault(require("./selectUser.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _selectCoupon = _interopRequireDefault(require("./selectCoupon.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    SelectUser: _selectUser.default,
    SelectCoupon: _selectCoupon.default
  },
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {
        groupId: [],
        tagId: [],
        templateId: null,
        userType: null
      },
      USER_TYPE_OPTIONS: [{
        name: '指定分组',
        value: 3
      }, {
        name: '指定标签',
        value: 4
      }],
      TYPE_TITLE: {
        3: '指定分组：',
        4: '指定标签：'
      },
      labelLists: [],
      groupList: [],
      tempsOption: [],
      selectVisible: false
    };
  },
  mounted: function mounted() {},
  methods: {
    throttle: _throttle.default,
    openInit: function openInit() {
      this.visible = true;
      this.pram = {
        groupId: [],
        tagId: [],
        templateId: null,
        userType: null
      };
      this.initSearch();
    },
    submitSend: function submitSend() {
      var _this = this;
      var _ref = this.pram || {},
        _ref$groupId = _ref.groupId,
        groupId = _ref$groupId === void 0 ? [] : _ref$groupId,
        _ref$tagId = _ref.tagId,
        tagId = _ref$tagId === void 0 ? [] : _ref$tagId,
        _ref$templateId = _ref.templateId,
        templateId = _ref$templateId === void 0 ? null : _ref$templateId,
        _ref$userType = _ref.userType,
        userType = _ref$userType === void 0 ? null : _ref$userType;
      var CHECK_MAP = [{
        noPass: !templateId,
        warnTips: '请选择消息模板！'
      }, {
        noPass: !userType,
        warnTips: '请选择用户类型！'
      }, {
        noPass: userType == 3 && !(groupId !== null && groupId !== void 0 && groupId.length),
        warnTips: '请先选择指定分组！'
      }, {
        noPass: userType == 4 && !(tagId !== null && tagId !== void 0 && tagId.length),
        warnTips: '请先选择指定标签！'
      }];
      var warnInfo = {};
      var isNoPass = CHECK_MAP === null || CHECK_MAP === void 0 ? void 0 : CHECK_MAP.some(function (item) {
        if (item.noPass) {
          warnInfo = item;
        }
        ;
        return item.noPass;
      });
      if (isNoPass && warnInfo.warnTips) {
        this.$message.warning(warnInfo.warnTips);
        return;
      }
      ;
      this.loading = true;
      userApi.sendUserMessages(this.pram).then(function (res) {
        _this.$message.success('操作成功！');
        _this.visible = false;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
      });
    },
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    initSearch: function initSearch() {
      var _this2 = this;
      this.groupList = [];
      this.labelLists = [];
      // 分组列表
      userApi.groupListApi({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this2.groupList = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
      //标签列表
      userApi.tagListApi({
        page: 1,
        limit: 9999
      }).then(function (res) {
        _this2.labelLists = (res === null || res === void 0 ? void 0 : res.list) || [];
      });
      this.searchTemp();
    },
    searchTemp: function searchTemp() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.tempsOption = [];
      userApi.searchTemps({
        keyword: keyword,
        page: 1,
        limit: 50
      }).then(function (res) {
        _this3.tempsOption = res || [];
      });
    },
    handleTempSearch: function handleTempSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchTemp(data);
      }, 300)();
    }
  }
};